<!--为了适配All选项的问题，对s-select包装多一次-->
<template>
  <s-select v-model="selected" v-bind="$attrs" v-on="$listeners">
    <s-option
      v-for="(item, i) in list"
      :label="item.label || item.name"
      :value="item.id"
      :key="item.id || i"
    ></s-option>
  </s-select>
</template>

<script>
import difference from 'lodash/difference'

export default {
  name: 'commonSelect',
  props: {
    value: [Number, String, Object, Array],
    list: {
      type: Array,
      default() {
        return []
      },
    },
    props: {
      type: Object,
      default() {
        return {
          label: 'name',
          value: 'id',
        }
      },
    },
  },
  data() {
    return {
      selected: this.value,
    }
  },
  watch: {
    selected: {
      handler(cur, old) {
        if (old && old.length > 0) {
          let diff = difference(cur, old)
          // 如果新选中的值是 All， 就返回[0]
          // 如果选中的值不是All, 但是之前的值包含All, 就把All去掉
          // 判断diff.length是否大于0，是因为重新给selected赋值后，再次触发watch，而此时diff得到的值为空数组[]
          if (diff.length > 0 && (diff[0] === '0' || cur[0] === '0')) {
            this.$emit('input', diff)
            return
          }
          this.$emit('input', cur)
        }
      },
    },
    value: {
      handler(n, o) {
        this.selected = n
      },
    },
  },
}
</script>

<style scoped></style>
